import React, { useState } from "react";
import { Form, Input, Button, Typography, message } from "antd";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG, ERROR_SENDING_OTP } from "../../constants/constants";
import { useHistory } from "react-router-dom";
import { routes } from "../../routes/Routes";
import { RightOutlined,ArrowRightOutlined } from "@ant-design/icons";

const { Title, Text, Link } = Typography;

const VerifyEmail = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const onAlreadyHaveAccountClick = () => {
        history.push(routes.registeredEmail.path);
    };

    const onFinish = async (values) => {

        setLoading(true);
        let obj = {
            Email: values.email
        }
        try {
            const res = await _NewapplicationService.verifyEmail(obj);
            if (res?.data?.IsSuccess) {
                setLoading(false);
                message.success(res?.data?.Message);
                history.push({
                    pathname: routes.VerifyOtp.path,
                    state: { applicantMailID: values.email },
                });
            }
            else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            message.error(err.Message || ERROR_SENDING_OTP);
        }

    };

    return (
        <LeftLayout>
            <div className="verify-email-container" style={{ maxWidth: 450 }}>
                <Title level={3} style={{ marginBottom: 32 }}>
                    Verify Your Email
                </Title>
                <Form
                    name="verify-email"
                    layout="vertical"
                    onFinish={onFinish}
                    requiredMark={true}
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: "Please enter your email address" },
                            {
                                type: "email",
                                message: "Please enter a valid email address",
                            },
                        ]}
                    >
                        <Input
                            placeholder="Enter your email address"
                            autoComplete="email"
                            maxLength={50}
                        />
                    </Form.Item>
                    <Text type="secondary" style={{ fontSize: 16 }}>
                        We will send an OTP to your email address for validation
                    </Text>
                    <Form.Item style={{ marginTop: 32 }}>
                        <Button
                            htmlType="submit"
                            loading={loading}
                            className="send-otp-btn"
                        >
                            Send OTP <ArrowRightOutlined />
                        </Button>
                    </Form.Item>

                    <Form.Item>
                        <Link onClick={onAlreadyHaveAccountClick}>
                            Already have an User Account? <RightOutlined />
                        </Link>
                    </Form.Item>
                </Form>
            </div>
        </LeftLayout>
    );
};

export default VerifyEmail;